import styled, { css } from 'styled-components';
import { SpacingToken, Stack, StackProps, getSpacingToken, getToken } from '@optimus-web/core';
import { BORDER_RADIUS_400 } from '../capitalThemeConstants';

interface CardCustomProps extends StackProps {
    paddingVertical?: SpacingToken;
    paddingHorizontal?: SpacingToken;
    background?: string;
}

export const CardCustom = styled(Stack)<CardCustomProps>`
    border-radius: ${BORDER_RADIUS_400};
    ${({ paddingVertical, paddingHorizontal, background }) => css`
        padding: ${getSpacingToken(paddingVertical || '900')}px ${getSpacingToken(paddingHorizontal || '500')}px;
        background: ${background || getToken('backgroundStaticFlat')};
    `}
`;
